module.exports = __webpack_public_path__ + "public/images/partners/sup-6.f29320fa238d529b93d9556b2d90bc5e.png";